import { reducer as ingenicoReducer } from './ingenico'
import { reducer as sixcardsReducer } from './sixcards'
import { reducer as monerisReducer } from './moneris'
import { reducer as pagseguroReducer } from './pagseguro'
import * as constants from './constants'
import { combineReducers } from 'redux'

const pspReducers = {
    INGENICO: ingenicoReducer,
    SIXCARDS: sixcardsReducer,
    MONERIS: monerisReducer,
    PAGSEGURO: pagseguroReducer,
}

const psePaymentBanks = (state = null, { type, banks }) => {
    switch (type) {
        case constants.SET_PSE_PAYMENT_BANKS:
            return banks
        default:
            return state
    }
}

const pixQrCodeData = (state = null, { type, qrCodeData: data }) => {
    switch (type) {
        case constants.SET_PIX_QR_CODE_DATA:
            return data
        default:
            return state
    }
}

export const reducer = combineReducers({
    creditCard: pspReducers[window.PAYMENT_SERVICE_PROVIDER],
    psePaymentBanks,
    pixQrCodeData,
})
